<template>
    <div class="nav">
        <el-row class="posiBox" >
            <a class="logoLink" href="/#/index"><img src="../assets/images/logo.png" alt="和峰科技"></a>

            <el-button type="text"  class="naBtn" @click="btnClick">
                <img src="../assets/images/img_5.png" alt="">
            </el-button>
        </el-row>
        <div class="popCloseDiv" v-show="navPop" @click="closeDiv">
            <div class="navPop" id="navPop" ref="box" @click.stop="navPopDiv">
                <div class="logo">
                    <a class="logoLink" href="/#/index" style="display: inline-block;">
                        <img src="../assets/images/logo_2.png" alt="和峰科技">
                    </a>
                </div>
                <div class="navCont">
                    <div class="navList moreLink">
                        <p><a href="javascript:void(0)" @click="aClick('proCont','manet','MANET')">MANET</a></p>
                        <div class="navLink">
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','MANET')">MANET</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','COFDM')">COFDM</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','MIMO')">MIMO</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','智能选频')">智能选频</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','跳频')">跳频</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','空间时分复用')">空间时分复用</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','载波聚合')">载波聚合</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','波束成形')">波束成形</a>
                            <a href="javascript:void(0)" @click="aClick('proCont','manet','干扰防御')">干扰防御</a>
                            <!--<a href="javascript:void(0)" @click="aClick('proCont','manet','静默与唤醒')">静默与唤醒 </a>-->
                        </div>
                    </div>
                    <div class="navList">
                        <p><a  href="javascript:void(0)" @click="aClick('contIndex','ky','')">波形系列</a></p>
                        <div class="navLink">
                            <a  href="javascript:void(0)" @click="aClick('contIndex','ky','')">鲲鱼系列</a>
                            <a  href="javascript:void(0)" @click="aClick('contIndex','hh','')">鸿鹄系列</a>
                            <a  href="javascript:void(0)" @click="aClick('contIndex','pn','')">鹏鸟系列</a>
                            <a  href="javascript:void(0)" @click="aClick('contIndex','zl','')">烛龙系列</a>
                            <a  href="javascript:void(0)" @click="aClick('contIndex','cl','')">苍鸾系列</a>
                            <a  href="javascript:void(0)" @click="aClick('contIndex','cm','')">重明系列</a>
                        </div>
                    </div>
<!--                    <div class="navList">
                        <p><a href="javascript:void(0)" @click="aClick('moduleList','core','')">模组系列</a></p>
                        <div class="navLink">
                            <a href="javascript:void(0)" @click="aClick('moduleList','core','')">核心模块</a>
                            <a href="javascript:void(0)" @click="aClick('moduleList','rf','')">射频功放模块</a>
                            <a href="javascript:void(0)" @click="aClick('moduleList','an','')">定制天线</a>
                            <a href="javascript:void(0)" @click="aClick('moduleList','video','')">视频编码模块</a>
                            <a href="javascript:void(0)" @click="aClick('moduleList','power','')">电源模块 </a>
                        </div>
                    </div>-->
                    <div class="navList">
                        <p><a href="#/aboutHQ" >关于和峰</a></p>
                        <div class="navLink noBorder">
                            <a href="#/aboutHQ">关于和峰</a>
                            <a href="#/joinHQ">招募精英</a>
                            <a href="#/contactUs">联系我们</a>
<!--                            <a href="#/newsHQ">和峰新闻</a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Nav',
    data(){
        return {
            navPop:false
        }
    },
    methods:{
        btnClick(){
            this.navPop = true;
        },
        autoSize(){
            let html = document.documentElement;
            let cliWidth = html.clientWidth;
            html.style.fontSize = 16 * ( cliWidth/1920 ) + 'px';
        },
        aClick(to,type,id){
            this.$router.push({
                path:`/${to}/${type}/${id}`,
            });
        },
        closeDiv(){
            this.navPop = false;
        },
        navPopDiv(){
            this.navPop = true;
        }
    },
    mounted () {
        window.onresize = ()=>{
            this.autoSize();
        }
    },
}
</script>

<style scoped>
    .noBorder{
        border-right: none !important;
    }

    .nav{
        width: 100%;
        height: 6.125rem;
        overflow: hidden;
    }
    .logoLink{
        display: block;
        width: 10.25rem;
        height: 2.8125rem;
        overflow: hidden;
        line-height: normal;
        margin: 1.5rem auto 0;
    }
    .logoLink img{
        width: 100%;
        height: 100%;
    }

    .posiBox{
        position: relative;
        line-height: 9.125rem;
    }
    .naBtn{
        position: absolute;
        display: block;
        width: 6.25rem;
        height: 6.125rem;
        top: 0;
        right: 0;
        border-radius:0;
        font-size: 1.25rem;
        color: #cccccc;
    }
    .naBtn:hover{
        background:#e7211a;
    }

    .popCloseDiv{
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 99999;
        top: 0;
        left: 0;
    }
    .navPop{
        width: 85.5rem;
        min-height: 25.5rem;
        background: #e7211a;
        z-index: 1;
        margin: -48px auto 0;
    }
    .logo{
        width: 100%;
        height: 2.8125rem;
        margin: 3rem auto 0;
        padding: 0;
        text-align: center;
    }
    .icon{
        font-size: 2.215rem;
        color: #ffffff;
        font-weight: bold;
        float: right;
        margin-right: 2.3125rem;
        cursor: pointer;
    }
    .navCont{
        width: max-content;
        height: auto;
        margin: 3.3125rem auto 0;
        padding: 3rem 0rem;
        overflow: hidden;
        display: inline-block;
    }
    .navList{
        width: max-content;
        height: auto;
        float: left;
        padding-left: 3.25rem;
        box-sizing: border-box;
    }
    .navList p{
        width: 100%;
        height: 1rem;
        text-align: left;
        font-size: 18px;
        color: #ffffff;
        margin: 0;
        font-family: AlibabaPuHuiTi;
        font-weight: bold;
    }
    .navList p a{
        text-decoration: none;
        color: #ffffff;
    }
    .navList .navLink{
        width: 100%;
        height: auto;
        margin-top: 2.9375rem;
        overflow: hidden;
        border-right: 0.125rem solid #fe8f8f;
    }
    .navList .navLink a{
        color: #ffffff;
        text-decoration: none;
        margin-right: 1rem;
        margin-bottom: 1rem;
        text-align: left;
        font-size: 16px;
        display: block;
        width: 7.5rem;
        height: auto;
        font-family: AlibabaPuHuiTi;
    }
    .navList .navLink a:hover{
        text-decoration: underline;
    }
    .moreLink{
        width: 20rem;
    }
    .moreLink a{
        float: left;
        margin-right: 0.875rem !important;
    }

</style>
